import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { CrudType } from "@core/enums/crud-type";
import { ServiceHelper } from "@core/helpers/service-helper";
import { CompositionRiskProfile } from "@core/models/composition-risk-profile.model";
import { RebalanceModel } from "@core/models/rebalance.model";
import { RiskProfile } from "@core/models/risk-profile.model";
import { TableSorting } from "@custom-types/sorting";
import { environment } from "@env/environment";
import { map, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class RebalanceService {
  constructor(private http: HttpClient) {}

  getRebalanceData$(sorting?: TableSorting): Observable<Array<RebalanceModel>> {
    const params = ServiceHelper.getListQueryParams(undefined, sorting);
    return this.http
      .get<
        Array<RebalanceModel>
      >(`${environment.BASE_URL}rebalance`, { params })
      .pipe(
        map((response: Array<RebalanceModel>): Array<RebalanceModel> => {
          return response;
        })
      );
  }

  deleteRebalance$(id: string): Observable<unknown> {
    return this.http.delete(`${environment.BASE_URL}rebalance/${id}`);
  }

  approveRebalance$(id: string): Observable<unknown> {
    return this.http.patch(
      `${environment.BASE_URL}rebalance/${id}/approve`,
      undefined
    );
  }

  declineRebalance$(id: string): Observable<unknown> {
    return this.http.patch(
      `${environment.BASE_URL}rebalance/${id}/decline`,
      undefined
    );
  }

  updateRebalanceExecutionDate$(
    rebalance: Partial<RebalanceModel>
  ): Observable<unknown> {
    return this.http.put(`${environment.BASE_URL}rebalance`, rebalance);
  }

  getRiskProfiles$(): Observable<Array<RiskProfile>> {
    let params = new HttpParams({});
    params = params.append("rebalanceRiskProfileFiltering", true);

    return this.http
      .get<Array<RiskProfile>>(`${environment.BASE_URL}riskprofile`, { params })
      .pipe(
        map((response: Array<RiskProfile>): Array<RiskProfile> => {
          return response;
        })
      );
  }

  getCompositionRiskProfiles$(
    id: string,
    filterRebalanceRiskProfile?: boolean
  ): Observable<Array<CompositionRiskProfile>> {
    let params = new HttpParams({});
    if (filterRebalanceRiskProfile) {
      params = params.append(
        "rebalanceRiskProfileFiltering",
        filterRebalanceRiskProfile
      );
    }
    return this.http
      .get<
        Array<CompositionRiskProfile>
      >(`${environment.BASE_URL}composition/risks/${id}`, { params })
      .pipe(
        map(
          (
            response: Array<CompositionRiskProfile>
          ): Array<CompositionRiskProfile> => {
            return response;
          }
        )
      );
  }

  saveRebalance$(
    rebalance: Partial<RebalanceModel>,
    id?: string
  ): Observable<unknown> {
    const create = id === "";

    return this.http[create ? CrudType.Post : CrudType.Put](
      `${environment.BASE_URL}rebalance`,
      rebalance
    );
  }
}
